import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

const Header = ({ title, darkMode, setDarkMode, onResetProgress }) => (
  <header className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
    <div className="flex items-center justify-between px-4 py-3">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
        {title}
      </h2>
      <div className="flex items-center space-x-3">
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="p-2 rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          {darkMode ? <SunIcon className="w-5 h-5" /> : <MoonIcon className="w-5 h-5" />}
        </button>
        <button
          onClick={onResetProgress}
          className="px-3 py-1.5 text-sm bg-red-500 hover:bg-red-600 text-white rounded-lg"
        >
          Reset Progress
        </button>
      </div>
    </div>
  </header>
);

export default Header;
